import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * useRTL Hook - Right-to-Left (RTL) dil desteği için
 * Arapça, Farsça, İbranice ve Urduca gibi RTL dilleri için otomatik yön kontrolü
 */
export const useRTL = () => {
  const { i18n } = useTranslation();
  
  // RTL dillerin listesi
  const isRTL = ['ar', 'fa', 'he', 'ur'].includes(i18n.language);
  
  useEffect(() => {
    // HTML root elementine dir ve lang attribute'larını ayarla
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [isRTL, i18n.language]);
  
  return isRTL;
};